module.exports = __webpack_public_path__ + "static/media/test18_3.6bfac834.png";